import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { DataService } from '../_services/data.service';

declare var toastr: any;

@Injectable()
export class PlayerService {
  private player: any;
  private playerSubject = new Subject<any>();
  private keepAfterNavigationChange = false;
  audio: any;
  refreshInterval: any;
  isPlaying: boolean;

  constructor(private router: Router, public dataService: DataService) {
    // clear alert message on route change
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.playerSubject.next();
        }
      }
    });

    this.audio = new Audio();
    this.isPlaying = true;
  }

  setPlayer(player: any, keepAfterNavigationChange = true) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.dataService.setPlayer(player);
    this.playerSubject.next(player);
  }

  getPlayer(): Observable<any> {
    return this.playerSubject.asObservable();
  }

  currentAudio() {
    return this.audio;
  }

  changeVolume(volume: number) {
    this.audio.volume = volume;
  }

  togglePlayer(run = true) {
    // console.log('togglePlayer');
    const player = this.dataService.currentPlayer();

    if (player) {
      this.audio.src = player.url;

      if (player.iconPlayer == undefined) {
        player.iconPlayer = 'fa-pause';
      }

      if (player._play == undefined) {
        player._play = false;
      }

      player._play = !player._play;

      if (player._play) {
        player.iconPlayer = 'fa-pause';
      } else {
        player.iconPlayer = 'fa-play';
      }

      if (player._play) {
        this.audio.play();
      } else {
        this.audio.pause();
      }

      this.dataService.callInfo(player).subscribe(info => {
        player.info = info;
        this.dataService.setPlayer(player);
        if (run) {
          this.setPlayer(player);
        }
        return this.audio.paused;
      });

      if(this.refreshInterval){
        clearInterval(this.refreshInterval);
      }

      this.refreshInterval = setInterval(() => {
        console.log('setInterval');
        this.dataService.callInfo(player).subscribe(info => {
          console.log('call info');
          console.log(info);
          player.info = info;
          this.dataService.setPlayer(player);
          if (run) {
            this.setPlayer(player);
          }
          return this.audio.paused;
        });
      }, 3000);
    }
  }
}
